/*global ajax_object*/
import $ from 'jquery';
import '../util/textarea_resizer';
export default {
  init() {
    // JavaScript to be fired on all pages
    $('.social-media-list .js-add-sm').on('click', function (e) {
      e.preventDefault();
      const newKey = parseInt($('input[name="counter_social_media"]').val()) + 1;
      $('.social-media-item[key="' + newKey + '"]').removeClass('hidden');
      $('input[name="counter_social_media"]').val(newKey);
    });

    $('.social-media-list .js-remove-sm').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.social-media-item').remove();
      $('input[name="counter_social_media"]').value = parseInt($('input[name="counter_social_media"]').value) - 1;
    });

    const agreeTermsAndCloseModal = () => {
      const checkboxElm = document.querySelector('input[name="accept_terms"]');
      if (checkboxElm) {
        checkboxElm.checked = true;
      }
      toggleModal();
    }

    const toggleModal = () => {
      const body = document.querySelector('body');
      const modal = document.querySelector('.modal');
      modal.classList.toggle('opacity-0');
      modal.classList.toggle('pointer-events-none');
      body.classList.toggle('modal-active');
    }

    const openmodal = document.querySelectorAll('.modal-open');
    if (openmodal) {
      for (let i = 0; i < openmodal.length; i++) {
        openmodal[i].addEventListener('click', function (event) {
          event.preventDefault();
          toggleModal();
        })
      }

      const overlay = document.querySelector('.modal-overlay')
      if (overlay) {
        overlay.addEventListener('click', toggleModal);
      }

      let closemodal = document.querySelectorAll('.modal-close')
      for (let i = 0; i < closemodal.length; i++) {
        closemodal[i].addEventListener('click', toggleModal);
      }

      let closeAndAgreeTerms = document.querySelectorAll('.modal-accept')
      for (let i = 0; i < closeAndAgreeTerms.length; i++) {
        closeAndAgreeTerms[i].addEventListener('click', agreeTermsAndCloseModal);
      }

      document.onkeydown = function (evt) {
        evt = evt || window.event
        let isEscape = false;
        if ("key" in evt) {
          isEscape = (evt.key === "Escape" || evt.key === "Esc")
        } else {
          isEscape = (evt.keyCode === 27)
        }
        if (isEscape && document.body.classList.contains('modal-active')) {
          toggleModal();
        }
      };
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.mobile-menu-toggle').on('click', e => {
      e.preventDefault();
      $('#mobile-menu').toggleClass('show');
      $('body').toggleClass('overflow-hidden');
    });

    let page = 1;
    const companySelect = document.getElementById('company-select');
    const loadMoreButton = document.getElementById('load-more-campaigns');

    if (companySelect) {
      companySelect.addEventListener('change', e => {
        const status = $('#load-more-campaigns').data('status')
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: ajax_object.ajaxurl,
          data: { action: 'get_campaigns', page: 0, companyId: e.target.value, status, nonce: ajax_object.nonce },
          success: response => {
            $('#campaign-list').html(response.items);

            if (response.max_num_pages > 1) {
              document.getElementById('load-more-campaigns').classList.remove('hidden');
              page = 1;
            } else {
              document.getElementById('load-more-campaigns').classList.add('hidden');
            }
          },
        });
      });
    }

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', e => {
        $(e.target).prop('disabled', true);
        const companySelect = document.getElementById('company-select');
        const companyId = companySelect ? companySelect.options[companySelect.selectedIndex].value : null;
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: ajax_object.ajaxurl,
          data: { action: 'get_campaigns', page, companyId, nonce: ajax_object.nonce, status: $(e.target).data('status') },
          success: response => {
            $(e.target).prop('disabled', false);
            $('#campaign-list').append(response.items);

            if (response.last_page) {
              document.getElementById('load-more-campaigns').classList.add('hidden');
            } else {
              page++;
            }
          },
        });
      });
    }

    //Show speech-bubble on input focus
    $('input.has-speech-bubble').focusin( function() {
      $(this).siblings('.speech-bubble-wrapper').addClass('show');
    })
    $('input.has-speech-bubble').focusout( function() {
      $(this).siblings('.speech-bubble-wrapper').addClass('hide');
      $(this).siblings('.speech-bubble-wrapper').removeClass('show');
    })

    function alignButton() {
      var $socialMediaLabel = $('.social-media-label');
      var $socialMediaLabel_button = $socialMediaLabel.parents('.social-media-content').siblings('button');
      if( $(window).width() < 768 ) {
        var $socialMediaLabel_height = $socialMediaLabel.outerHeight() + 12;
        $socialMediaLabel_button.css('margin-top', $socialMediaLabel_height + 'px');
      } else {
        $socialMediaLabel_button.css('margin-top', '0px');
      }
    }

    $(window).resize(function() {
      if( $(window).width() < 768 ) {
        alignButton();
      }
    })

    if( $(window).width() < 768 ) {
      alignButton();
    }

    $('textarea').autogrow();

  },
};
